import React from "react";
import {
  Container,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  CssBaseline,
  Typography,
} from "@mui/material";
import * as gkApi from "../../api/gkApi";
import { withRouter } from "../common/WithRouter";

class ImportDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      companyName: "",
      year: "",
      quarter: "",
      page: 0,
      rowsPerPage: 10,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    try {
      const { id, year, quarter } = this.props.params;
      if (year) this.setState({ year });
      if (quarter) this.setState({ quarter });
      const list = await gkApi.getImportList(id, year, quarter);
      if (list) {
        const companyName = list[0].companyName;
        if (companyName) this.setState({ companyName });
        this.setState({ list });
      }
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  subtotal = (data) => {
    const sum = this.state.list.map((item) => item[data]);
    return sum.reduce((a, b) => a + b, 0).toLocaleString("de-DE");
  };

  render() {
    const layoutStyle = {
      width: "100%",
      paddingTop: 80,
      margin: "auto",
    };

    const paperStyle = {
      width: "100%",
      padding: 20,
    };

    const tableWrapperStyle = {
      maxHeight: 800,
      overflow: "auto",
    };

    const headDarkStyle = {
      backgroundColor: "#e6e6e6",
      fontWeight: "bold",
      fontSize: 16,
    };

    const headLightStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };

    const totalRowStyle = {
      backgroundColor: "#eeeeee",
    };

    const emptyPaperStyle = {
      textAlign: "center",
      verticalAlign: "middle",
      lineHeight: "20px",
    };

    const formControlStyle = {
      minWidth: "70%",
      margin: "0 40px",
    };

    return (
      <Container maxWidth="lg">
        <main style={layoutStyle}>
          <Paper style={paperStyle}>
            <React.Fragment>
              <CssBaseline />
              <Grid container>
                <Typography variant="h6" gutterBottom>
                  Data for:
                </Typography>
                <Grid item lg={3}>
                  <FormControl fullWidth style={formControlStyle}>
                    <InputLabel>Bedrift</InputLabel>
                    <Select name="companyName" value="companyName">
                      <MenuItem value="companyName">
                        {this.state.companyName}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={3}>
                  <FormControl fullWidth style={formControlStyle}>
                    <InputLabel>År</InputLabel>
                    <Select name="year" value="year">
                      <MenuItem value="year">{this.state.year}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={3}>
                  <FormControl fullWidth style={formControlStyle}>
                    <InputLabel>Kvartal</InputLabel>
                    <Select name="quarter" value="quarter">
                      <MenuItem value="quarter">{this.state.quarter}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12}>
                  {this.state.list && this.state.list.length > 0 ? (
                    <Paper style={{ width: "100%", marginTop: 10 }}>
                      <div style={tableWrapperStyle}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <TableCell style={headLightStyle}>
                                Forsikringsselskapets-
                                <br />
                                nasjonalitet
                              </TableCell>
                              <TableCell
                                align="center"
                                colSpan={3}
                                style={headDarkStyle}
                              >
                                Antall meldte skader
                              </TableCell>
                              <TableCell
                                align="center"
                                colSpan={3}
                                style={headLightStyle}
                              >
                                Utbetalt erstatning
                              </TableCell>
                              <TableCell
                                align="center"
                                colSpan={3}
                                style={headDarkStyle}
                              >
                                Reserve
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={headLightStyle}></TableCell>
                              <TableCell align="right" style={headDarkStyle}>
                                Person
                              </TableCell>
                              <TableCell align="right" style={headDarkStyle}>
                                Materiell
                              </TableCell>
                              <TableCell align="right" style={headDarkStyle}>
                                Sum
                              </TableCell>
                              <TableCell align="right" style={headLightStyle}>
                                Person
                              </TableCell>
                              <TableCell align="right" style={headLightStyle}>
                                Materiell
                              </TableCell>
                              <TableCell align="right" style={headLightStyle}>
                                Sum
                              </TableCell>
                              <TableCell align="right" style={headDarkStyle}>
                                Person
                              </TableCell>
                              <TableCell align="right" style={headDarkStyle}>
                                Materiell
                              </TableCell>
                              <TableCell align="right" style={headDarkStyle}>
                                Sum
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.list
                              .slice(
                                this.state.page * this.state.rowsPerPage,
                                this.state.page * this.state.rowsPerPage +
                                this.state.rowsPerPage
                              )
                              .map((item, index) => (
                                <TableRow hover key={index}>
                                  <TableCell>{item.country}</TableCell>
                                  <TableCell align="right">
                                    {item.qtyPerson.toLocaleString("de-DE")}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.qtyMaterial.toLocaleString("de-DE")}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.qtySum.toLocaleString("de-DE")}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.compensationPerson.toLocaleString(
                                      "de-DE"
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.compensationMaterial.toLocaleString(
                                      "de-DE"
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.compensationSum.toLocaleString(
                                      "de-DE"
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.reservesPerson.toLocaleString(
                                      "de-DE"
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.reservesMaterial.toLocaleString(
                                      "de-DE"
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    {item.reservesSum.toLocaleString("de-DE")}
                                  </TableCell>
                                </TableRow>
                              ))}
                            <TableRow style={totalRowStyle}>
                              <TableCell>Total</TableCell>
                              <TableCell align="right">
                                {this.subtotal("qtyPerson")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("qtyMaterial")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("qtySum")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("compensationPerson")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("compensationMaterial")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("compensationSum")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("reservesPerson")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("reservesMaterial")}
                              </TableCell>
                              <TableCell align="right">
                                {this.subtotal("reservesSum")}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </div>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 50]}
                        component="div"
                        count={this.state.list.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </Paper>
                  ) : (
                    <Paper style={emptyPaperStyle}>Ingen treff</Paper>
                  )}
                </Grid>
              </Grid>
            </React.Fragment>
          </Paper>
        </main>
      </Container>
    );
  }
}

export default withRouter(ImportDetail);
